class ProjectService {
  initRequest: RequestInit;

  constructor() {
    this.initRequest = {
      method: "GET",
      referrerPolicy: "unsafe-url",
      headers: {
        "Content-Type": "application/json",
      },
    };
  }

  async getProjectInfoByHost(baseUri: string, hostname: string) {
    const response = await fetch(`${baseUri}/hostname/${hostname}`, {
      ...this.initRequest,
    });
    if (!response.ok) {
      throw new Error(`Status: ${response.status}`);
    }
    const responseContent = await response.json();
    return responseContent?.data;
  }

  async getProjectInfo(baseUri: string, baseHost: string, host?: string) {
    const response = await fetch(`${baseUri}/info`, {
      ...this.initRequest,
      referrer: "about:client",
    });
    if (!response.ok) {
      const hostname =
        host ?? localStorage.getItem("coliving_hostname") ?? baseHost ?? "";
      return this.getProjectInfoByHost(baseUri, hostname);
    }
    const responseContent = await response.json();
    return responseContent?.data;
  }

  async getProjectInfoByID(baseUri: string, projectId: string) {
    const response = await fetch(`${baseUri}/${projectId}`, {
      ...this.initRequest,
    });
    if (!response.ok) {
      throw new Error(`Status: ${response.status}`);
    }
    return response;
  }
}

export default new ProjectService();
